/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import { Img } from "./element/Img";
import { App } from "../../api/apiCalls";
import { Link } from "react-router-dom";

interface AppItem {
  app: App;
}

export default function AppCardRow({ app }: AppItem) {
  return (
    <div className="col-lg-3 col-sm-6 mb-3">
      <div className="apps-row-card">
        <Link to={"/app-details/" + app.appId}>
          <div className="card border-0 rounded-0">
            <div className="row">
              <div className="col-sm-4 col-3 pr-0">
                <div className="apps-row-card__ratings">
                  <i className="fas fa-star"></i>
                  {Math.round(app.rating)}
                </div>
                <Img src={app.appLogo} className="card-img-top rounded-0" />
              </div>
              <div className="col-sm-8 col-9">
                <div className="card-body px-0 py-2">
                  <p className="font-weight-bold m-0 card-body__text-1">
                    {`${app.name.substring(0, 20)}${
                      app.name.length > 20 ? "..." : ""
                    }`}
                  </p>
                  <p className="card-body__text-2 sub-text">
                    {app.developerName}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
